"use client";

import { useEffect } from "react";
import { toast } from "sonner";
import { DeveloperSection } from "../components/DeveloperSection";
import { FAQTeaser } from "../components/FAQTeaser";
import { Features } from "../components/Features";
import { FinalCTA } from "../components/FinalCTA";
import { Hero } from "../components/Hero";
import { HowItWorks } from "../components/HowItWorks";
import { PricingTeaser } from "../components/PricingTeaser";
import { ProblemSolution } from "../components/ProblemSolution";
import { Security } from "../components/Security";
import { SocialProof } from "../components/SocialProof";
import { Templates } from "../components/Templates";

export default function HomePage() {
  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth < 1024;
      if (isMobile) {
        toast.info("Optimization in progress", {
          description:
            "For the best workflow building experience, please switch to a desktop screen.",
          duration: 4000,
        });
      }
    };

    // Small delay to ensure the Toaster component is fully mounted
    const timer = setTimeout(checkMobile, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* <ScrollToTop /> */}
      {/* <ScrollProgress /> */}
      {/* <CookieBanner /> */}

      <main>
        <Hero />
        <SocialProof />
        <ProblemSolution />
        <HowItWorks />
        <Templates />
        <Features />
        <DeveloperSection />
        <Security />
        <PricingTeaser />
        <FAQTeaser />
        <FinalCTA />
      </main>
    </div>
  );
}
